// The broker JWT's `typ` claim, apart from the zod schemas in ./session so a
// Convex deployment can import the values without bundling zod.

export const USER_SESSION_TYP = "user_session";
export const READER_SESSION_TYP = "reader_session";
export type SessionTyp = typeof USER_SESSION_TYP | typeof READER_SESSION_TYP;

/**
 * The `typ` of a verified identity, or null when it carries none or one this
 * repo does not mint. Structural so it reads a Convex `UserIdentity`, where
 * custom claims surface as top-level keys, as readily as a parsed payload.
 */
export function sessionTypOf(
  identity: object | null | undefined,
): SessionTyp | null {
  const typ =
    identity !== null && identity !== undefined && "typ" in identity
      ? identity.typ
      : undefined;
  return typ === USER_SESSION_TYP || typ === READER_SESSION_TYP ? typ : null;
}
